<template>
  <div
    class="vendor-listing-section mt-4"
    v-if="getSelectedWpVariantProducts && getSelectedWpVariantProducts.length > 1"
  >
    <h5 class="heading"
								data-test="wpVariantProductListingSectionHeading"
								id="wpVariantProductListingSectionHeading">
      Similar Product Options
    </h5>
    <div class="vendor-listing-wrapper">
      <div
        class="vendor-listing-item"
        v-for="(product, index) in getSelectedWpVariantProducts.filter(product => productId !== product.product_id).slice(0, 4)"
        :key="index"
      >
        <div
          class="left-s"
          @click.prevent="selectedVariantProduct(product)"
          style="cursor: pointer"
        >
          <div
            class="price"
            v-if="product.product_details&&product.product_details.image_URL_1"
          >
            <img
              :src="product.product_details.image_URL_1"
              style="width: 25px; height: 25px; object-fit: contain;"
              alt=""
														:data-test="'wpVariantProductListingSectionImg'+index"
														:id="'wpVariantProductListingSectionImg'+index"
            >
            <!--{{(vendor.promotional_prices &&-->
            <!--vendor.promotional_prices.length > 0)?-->
            <!--vendor.promotional_prices[0].promotion_applied_price:-->
            <!--vendor.price | currencyConversion-->
            <!--}}-->
          </div>
          <div class="soldby">
            <span style="display: block;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 100px;
                  overflow: hidden"
																		:data-test="'wpVariantProductListingSectionPdtName'+index"
																		:id="'wpVariantProductListingSectionPdtName'+index">
              {{product.product_name}}
            </span>
          </div>
          <!--<a href="#">More Details</a>-->
        </div>
        <div class="left-s">
          <div class="price"
															style="display: block;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 100px;"
            v-for="(vendor, index) in product.vendor_product_inventories.slice(0,1)"
            :key="index"
												:data-test="'wpVariantProductListingSectionVendorPrice'+index"
												:id="'wpVariantProductListingSectionVendorPrice'+index"
          >
            {{(vendor && vendor.promotional_prices &&
            vendor.promotional_prices.length > 0)?
            vendor.promotional_prices[0].promotion_applied_price:
            vendor.price | currencyConversion
            }}
          </div>
          <div class="soldby">
            <p style="display: block;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 100px;
																		overflow: hidden"
															v-if="product.vendor_product_inventories && product.vendor_product_inventories[0] && product.vendor_product_inventories[0].vendor_name"
															:data-test="'wpVariantProductListingSectionSoldByPara'+index"
															:id="'wpVariantProductListingSectionSoldByPara'+index">
              Sold by:
              <span :data-test="'wpVariantProductListingSectionVendorName'+index"
																				:id="'wpVariantProductListingSectionVendorName'+index">
															{{product.vendor_product_inventories[0].vendor_name}}</span>
            </p>
          </div>
          <!--<a href="#">More Details</a>-->
        </div>
        <div class="right-s">
          <cart-action
            :is-add-to-cart="true"
            :is-buy-now="false"
            :pdp="true"
            :fav="true"
            :product="product"
            :vendor-id="product.vendor_product_inventories[0].vendor_id"
            v-if="product.vendor_product_inventories[0] && product.vendor_product_inventories[0].available_stock && product.vendor_product_inventories[0].available_stock > 0"
          />
        </div>
      </div>
    </div>
    <div
      class="vendor-listing-footer"
      v-if="getSelectedWpVariantProducts && getSelectedWpVariantProducts.length > 3"
    >
      <p data-test="wpVariantProductListingSectionVarientPdt"
									id="wpVariantProductListingSectionVarientPdt">
        <router-link to="/product_description/productVariantListing"
																					data-test="wpVariantProductListingSectionVarientPdtLength"
																					id="wpVariantProductListingSectionVarientPdtLength">
          {{getSelectedWpVariantProducts.length}} offers
        </router-link>
        from
        <span data-test="wpVariantProductListingSectionVarientPdtPrice"
														id="wpVariantProductListingSectionVarientPdtPrice">
          {{getSelectedWpVariantProducts[0].vendor_product_inventories[0].price | currencyConversion}}
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import CartAction from '@/components/actions/cart/CartAction'
import { mapGetters } from 'vuex'
import { productApi } from '../../../../../../services/ApiServices/productApi'

export default {
	name: 'variant-product-listing-section',
	props: {
		groupId: {
			type: String,
			default: ''
		},
		productId: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			productData: []
		}
	},
	components: {
		CartAction
	},
	computed: {
		...mapGetters('productselected', ['getSelectedWpVariantProducts'])
	},
	methods: {
		selectedVariantProduct (product) {
			this.$router.push({
				name: 'ProductDetails',
				path: '/product_description',
				query: {
					productName: product.product_name,
					productId: product.product_id,
					productCategoryId: product.product_category_id
				}
			})
		}
	},
	mounted () {
		if (this.groupId) {
			productApi.getSimilarVariantProducts(this.groupId)
				.then((res) => {
					if (res.data.length > 0) {
						this.productData = res.data
					}
				})
		}
	},
	watch: {
		groupId () {
			productApi.getSimilarVariantProducts(this.groupId)
				.then((res) => {
					if (res.data.length > 0) {
						this.productData = res.data
					}
				})
		}
	}
}
</script>

<style scoped>
</style>
